import React from 'react';

export function Navbar() {

    return (
        <>
            <div className="topbar">
                <div className="wrap">
                    <span className="mono a"><span className="dot"></span>Australian brand distribution</span>
                    <span className="mono b">Marketplaces · Retail · Direct</span>
                    <span className="mono">Est. 2026</span>
                </div>
            </div>
            <header className="nav">
                <div className="wrap">

                    <a
                        className="logo"
                        href="/"
                        onClick={(e) => {
                            e.preventDefault();
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                            });
                        }}
                    >
                        <span className="a">HOME</span>
                        <span className="b">2</span>
                        <span className="c">OUTDOOR</span>
                    </a>

                    <nav className="links">
                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                document.getElementById("model")?.scrollIntoView({
                                    behavior: "smooth",
                                });
                            }}
                        >
                            Model
                        </a>

                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                document.getElementById("channels")?.scrollIntoView({
                                    behavior: "smooth",
                                });
                            }}
                        >
                            Channels
                        </a>

                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                document.getElementById("program")?.scrollIntoView({
                                    behavior: "smooth",
                                });
                            }}
                        >
                            Brand program
                        </a>

                        <a
                            href="/"
                            onClick={(e) => {
                                e.preventDefault();
                                document.getElementById("company")?.scrollIntoView({
                                    behavior: "smooth",
                                });
                            }}
                        >
                            Company
                        </a>
                    </nav>

                    <a
                        className="navcta"
                        href="/"
                        onClick={(e) => {
                            e.preventDefault();
                            document.getElementById("partner")?.scrollIntoView({
                                behavior: "smooth",
                            });
                        }}
                    >
                        Bring your brand <span>→</span>
                    </a>

                </div>
            </header>
        </>

    )

}


